import { useQuery } from "@tanstack/react-query";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import {
	type GetClientFinancialPlanExpensesV2FetchResponse,
	getClientFinancialPlanExpensesV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export type ExpensesQueryData = Extract<
	GetClientFinancialPlanExpensesV2FetchResponse,
	{ status: 200 }
>["data"];

export const useExpenseQuery = () => {
	return useQuery({
		queryKey: FinanceKeys.expense(),
		queryFn: processResponse(() => getClientFinancialPlanExpensesV2()),
	});
};
